import {
  LOADER_STATUS,
  CHAT_SEND_MESSAGE,
  CHAT_RECEIVE_MESSAGE,
  CHAT_UPDATE_STREAMING_MESSAGE,
  CHAT_FINALIZE_STREAMING_MESSAGE,
  CHAT_SET_ERROR,
  CHAT_CLEAR_ERROR,
  CHAT_CLEAR_MESSAGES,
  CHAT_SET_TYPING,
  CHAT_SET_ACTIVE_SESSION,
} from "./constants";

// Initial State
const initialState = {
  loaderStatus: false,
  messages: [],
  error: '',
  isTyping: false,
  activeSessionId: null,
};

function floatingChatReducer(state = initialState, action) {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };

    case CHAT_SEND_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };

    case CHAT_RECEIVE_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };

    case CHAT_UPDATE_STREAMING_MESSAGE:
      return {
        ...state,
        messages: state.messages.map(msg => 
          msg.id === action.payload.id 
            ? { ...msg, text: action.payload.text, isStreaming: true }
            : msg
        ),
      };

    case CHAT_FINALIZE_STREAMING_MESSAGE:
      return {
        ...state,
        messages: state.messages.map(msg => 
          msg.id === action.payload.id 
            ? { ...msg, text: action.payload.text, sources: action.payload.sources, isStreaming: false }
            : msg
        ),
      };

    case CHAT_SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case CHAT_CLEAR_ERROR:
      return {
        ...state,
        error: '',
      };

    case CHAT_CLEAR_MESSAGES:
      return {
        ...state,
        messages: [],
        error: '',
      };

    case CHAT_SET_TYPING:
      return {
        ...state,
        isTyping: action.payload,
      };

    case CHAT_SET_ACTIVE_SESSION:
      return {
        ...state,
        activeSessionId: action.payload,
      };

    default:
      return state;
  }
}

export default floatingChatReducer;